import { Component } from '@angular/core';

@Component({
  selector: 'sp-watermark',
  template: `
    <div class="watermark">
      <div class="voided">VOIDED</div>
    </div>
  `,
  styleUrls: ['./watermark.component.scss'],
})
export class WatermarkComponent {}
